module.exports = __webpack_public_path__ + "img/search.e6df2fc7.png";